<template>
  <div class="page-register">
    <div class="container">
      <div class="register__head">
        <h2>{{ $t('register.title') }}</h2>
      </div>
      <div class="register-main">
        <pro-form
          label-width="160px"
          label-suffix=":"
          label-position="left"
          :model="model"
          :fields="fields"
          :rules="rules"
          :submitter="{
            submitButtonProps: {
              loading
            },
            submitText: $t('register.submit-text'),
            resetText: $t('register.reset-text')
          }"
          @submit="submit"
        ></pro-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as ConstantRouter from '@/constant/router'
import queryString from 'query-string'

export default {
  data() {
    const t = this.$t.bind(this)
    return {
      loading: false,
      model: {
        email: '',
        password: '',
        firstName: '',
        name: '',
        telephone: '',
        idNumber: '',
        occupation: undefined,
        address: '',
        addressDetail: '',
        postCode: ''
      },
      fields: [
        {
          type: 'input',
          formItemProps: {
            label: t('register.email'),
            prop: 'email'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'password',
          formItemProps: {
            label: t('register.password'),
            prop: 'password'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'input',
          formItemProps: {
            label: t('register.first-name'),
            prop: 'firstName'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'input',
          formItemProps: {
            label: t('register.name'),
            prop: 'name'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'input',
          formItemProps: {
            label: t('register.telephone'),
            prop: 'telephone'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'input',
          formItemProps: {
            label: t('register.idNumber'),
            prop: 'idNumber'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'input',
          formItemProps: {
            label: t('register.occupation'),
            prop: 'occupation'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'input',
          formItemProps: {
            label: t('register.country-region'),
            prop: 'address'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },
        {
          type: 'input',
          formItemProps: {
            label: t('register.country-region-detail'),
            prop: 'addressDetail'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        },

        {
          type: 'input',
          formItemProps: {
            label: t('register.post-code'),
            prop: 'postCode'
          },
          attributes: {
            placeholder: t('register.placeholder-input')
          }
        }
      ],
      rules: {
        email: [
          {
            required: true,
            message: t('register.placeholder-input'),
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: t('register.placeholder-input'),
            trigger: 'change'
          }
        ],
        firstName: [
          {
            required: true,
            message: t('register.placeholder-input'),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: t('register.placeholder-input'),
            trigger: 'change'
          }
        ],
        telephone: [
          {
            required: true,
            message: t('register.placeholder-input'),
            trigger: 'change'
          }
        ],
        idNumber: [
          {
            required: true,
            message: t('register.placeholder-input'),
            trigger: 'change'
          }
        ],
        occupation: [
          {
            required: true,
            message: t('register.placeholder-input'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    channel() {
      const query = queryString.parse(location.search)
      return query.channel
    }
  },
  mounted() {
    console.log(queryString.parse(location.search))
  },
  methods: {
    async submit(data) {
      const t = this.$t.bind(this)
      this.loading = true
      const [err] = await this.$serve.user.userAdd({
        data: {
          ...data,
          channel: this.channel
        }
      })
      this.loading = false
      if (err) return
      this.$message.success(t('register.message-submit-success'))
      this.$router.push({
        name: ConstantRouter.COMPETITOR_LOGIN
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-register {
  min-height: 100vh;
  overflow: hidden;
  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%);

  .container {
    width: 576px;
    margin: 60px auto;
    padding: 20px;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.2);
    background: #fff;
    border-radius: 4px;
  }
}
.register__head {
  text-align: center;
  margin-bottom: 40px;
}
.register-main {
  width: 500px;
  margin: 0 auto;
}

@media (max-width: 576px) {
  .page-register {
    .container {
      width: 100%;
      margin: 0;
      padding: 10px;
    }
  }

  .register-main {
    width: 100%;
  }
}
</style>
